<template>
    <section class="section_soantailieu">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/soan-tai-lieu">Soạn tài liệu</router-link></li>
                    <!-- <li>
                        <router-link v-if="ebooksClass&&ebooksClass.bookType&&ebooksClass.bookType.bookTypeId" :to="{ name: 'ebook-class', params: {id: ebooksClass.bookClass.classId, typeId: ebooksClass.bookType.bookTypeId} }" title="">
                        {{ebooksClass.bookType.name}}
                        </router-link>
                    </li> -->
                </ul>
            </div>
        </div>
        <div class="container margin-top-10">
            <div class="tab-main-prepare_document">

                <div class="row">
                    <div class="col-md-4">
                        <h4 class="item-tab-main"
                            :class="typeActiveTab == tabElectronicLectures ? 'active' : 'not_active'"
                            @click="handleChangeTab(tabElectronicLectures)">
                            <strong class="title">Soạn bài giảng điện tử</strong>
                            <div v-if="typeActiveTab == tabElectronicLectures" class="bg-item">

                            </div>
                        </h4>

                    </div>
                    <div class="col-md-4">
                        <h4 class="item-tab-main"
                            :class="typeActiveTab == tabExcerciseClassSchool ? 'active' : 'not_active'"
                            @click="handleChangeTab(tabExcerciseClassSchool)">
                            <strong>Soạn bài tập/bài kiểm tra</strong>
                            <div v-if="typeActiveTab == tabExcerciseClassSchool" class="bg-item">

                            </div>
                        </h4>

                    </div>
                    <div class="col-md-4">
                        <h4 class="item-tab-main" :class="typeActiveTab == tabLessonPlanning ? 'active' : 'not_active'"
                            @click="handleChangeTab(tabLessonPlanning)">
                            <strong>Soạn kế hoạch bài dạy</strong>
                            <div v-if="typeActiveTab == tabLessonPlanning" class="bg-item">

                            </div>
                        </h4>

                    </div>

                </div>
            </div>
            <div class="tab-body-prepare_document">
                <ElectronicLectures v-if="typeActiveTab == tabElectronicLectures" />
                <ExcerciseClassSchool v-if="typeActiveTab == tabExcerciseClassSchool" />
                <LessonPlanning v-if="typeActiveTab == tabLessonPlanning" />
            </div>

        </div>
    </section>
</template>
<script>
import { getAuth } from "@/utils/jwt";
import { ROLE_TEACHER, ROLE_PUPIL } from "@/store/auth/constants";
import debounce from "@/directives/debounce";
import ElectronicLectures from './_components/ElectronicLectures.vue'
import ExcerciseClassSchool from './_components/ExcerciseClassSchool.vue'
import LessonPlanning from './_components/LessonPlanning.vue'
export default {
    directives: { debounce },
    components: {
        ElectronicLectures,
        ExcerciseClassSchool,
        LessonPlanning
    },
    data() {
        return {
            typeActiveTab: 2,
            tabExcerciseClassSchool: 1,
            tabElectronicLectures: 2,
            tabLessonPlanning: 3,
            authInfo: getAuth(),
            roleTeacher: ROLE_TEACHER,
            roleHocSinh: ROLE_PUPIL,
        }
    },
    mounted() {
        // if (this.authInfo.roleCode == this.roleTeacher) {
        //     this.$router.push('/soan-tai-lieu')
        // } else {
        //     this.$router.push('/')
        // }
        if (this.authInfo.roleCode !== this.roleTeacher) {
            this.$router.push('/')
        }
        if (this.$route.query.tab) {
            this.typeActiveTab = this.$route.query.tab
        }

    },
    methods: {
        handleChangeTab(tab) {
            this.typeActiveTab = tab
        }
    }
}
</script>
<style lang="scss" scoped>
.tab-main-prepare_document {
    .item-tab-main {
        margin-top: 10px;
        cursor: pointer;
        position: relative;

        .title {
            z-index: 1;

        }

        .bg-item {
            width: 75px;
            height: 40px;
            position: absolute;
            background: #b7ddf9;
            top: -5px;
            left: -20px;
            z-index: -1;
            border-bottom-left-radius: 30px;
            border-top-left-radius: 15px;
            border-top-right-radius: 30px;
        }
    }

    .not_active {
        color: #869aa9;
    }

    .active {
        color: #2740b9 !important;
    }
}

.margin-top-10 {
    margin-top: 10px;
}
</style>